import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageShell from './LegalPageShell';
import { LEGAL_CONTROLLER } from './legalConfig';

/**
 * Cookie / terminal-storage notice (Law 506/2004 + GDPR) — draft for DPO review.
 */
export default function CookiePolicy() {
  const c = LEGAL_CONTROLLER;

  return (
    <LegalPageShell title="Cookie Policy" path="/cookies">
      <p>
        This Cookie Policy explains how <strong>{c.productName}</strong> stores or accesses
        information on your device when you visit <strong>{c.siteUrl}</strong>, in line with
        Romanian Law no. 506/2004 and the GDPR. More detail on personal data is in our{' '}
        <Link to="/privacy">Privacy Policy</Link>.
      </p>

      <h2>1. What are cookies and similar technologies?</h2>
      <p>
        Cookies are small text files. We also use browser <strong>localStorage</strong> for consent
        preferences and workspace settings. Law 506/2004 applies to storing or accessing information
        on your terminal equipment, not only traditional cookies.
      </p>

      <h2>2. How we ask for consent</h2>
      <ul>
        <li>
          <strong>Accept necessary</strong> — essential storage only; Analytics &amp; Ads stay off.
        </li>
        <li>
          <strong>Accept all (Analytics &amp; Ads)</strong> — loads Google Tag Manager (when
          configured) and related measurement tags.
        </li>
      </ul>
      <p>
        Non-essential tags are not injected until you choose Accept all. You can change your mind
        anytime via <strong>Manage cookies</strong> in the footer or the consent banner controls.
      </p>

      <h2>3. Cookie / storage table</h2>
      <div className="overflow-x-auto rounded-lg border border-white/10">
        <table className="w-full border-collapse text-left text-xs">
          <thead className="bg-slate-950/80 text-[10px] uppercase tracking-wider text-slate-400">
            <tr>
              <th className="px-2 py-2">Name</th>
              <th className="px-2 py-2">Type</th>
              <th className="px-2 py-2">Purpose</th>
              <th className="px-2 py-2">Duration</th>
              <th className="px-2 py-2">Provider</th>
            </tr>
          </thead>
          <tbody className="text-slate-300">
            <tr className="border-t border-white/10">
              <td className="px-2 py-2 font-mono">cybertracer_cookie_consent</td>
              <td className="px-2 py-2">Necessary</td>
              <td className="px-2 py-2">Stores consent choice + evidence (version, timestamp)</td>
              <td className="px-2 py-2">Until changed / cleared</td>
              <td className="px-2 py-2">CyberTracer (1st party)</td>
            </tr>
            <tr className="border-t border-white/10">
              <td className="px-2 py-2 font-mono">Session / SSO cookies</td>
              <td className="px-2 py-2">Necessary (admin)</td>
              <td className="px-2 py-2">Authenticate authorised Admin Console operators</td>
              <td className="px-2 py-2">Session / provider policy</td>
              <td className="px-2 py-2">CyberTracer / Google OAuth</td>
            </tr>
            <tr className="border-t border-white/10">
              <td className="px-2 py-2 font-mono">Readability / UI prefs</td>
              <td className="px-2 py-2">Necessary / functional</td>
              <td className="px-2 py-2">Remember accessibility / display preferences</td>
              <td className="px-2 py-2">Local until cleared</td>
              <td className="px-2 py-2">CyberTracer (1st party)</td>
            </tr>
            <tr className="border-t border-white/10">
              <td className="px-2 py-2 font-mono">_ga / _gid / gtm* (typical)</td>
              <td className="px-2 py-2">Analytics / Ads (optional)</td>
              <td className="px-2 py-2">Measure traffic and campaign performance via GTM/GA4</td>
              <td className="px-2 py-2">Per Google tag settings</td>
              <td className="px-2 py-2">Google (3rd party)</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-500">
        Exact Google cookie names depend on the live GTM container. Counsel should attach the
        container export or Consent Mode configuration.
      </p>

      <h2>4. Withdrawing consent</h2>
      <p>
        Use <strong>Manage cookies</strong> → choose Necessary only, or clear site data in your
        browser. Withdrawal does not affect the lawfulness of prior processing based on consent.
      </p>

      <h2>5. Contact</h2>
      <p>
        Questions:{' '}
        <a href={`mailto:${c.email}`}>{c.email}</a>. Supervisory authority:{' '}
        <a href={c.supervisoryAuthority.url} target="_blank" rel="noopener noreferrer">
          ANSPDCP
        </a>
        .
      </p>
    </LegalPageShell>
  );
}
